"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { submitting: false };
        this.fhandler = new FormHandler({
            key: 'add-user',
            autosave: true
        });
        this.fhandler.bind(this);
    },
    onMount: function () {
        const title = 'Adding User';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/add-user'
        })).on('reset', () => GState.activity.remove(title));
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.fullname)
            return this.state.formError.fullname = true;
        if (!Form.email)
            return this.state.formError.email = true;
        if (!Form.accountType)
            return this.state.formError.accountType = true;
        this.state.submitting = true;
        try {
            const {error, message} = await Request('/invitation/send', 'POST', Form);
            this.state.submitting = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            this.fhandler.alert(error);
        }
    },
    onReset: function () {
        this.fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Apps/Edit.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Select_template = require("../../../components/Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "form-group"
      },
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("0004a0"),
    marko_node0 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "font-small-4 text-right mt-2"
      },
    marko_attrs5 = {
        "class": "text-primary"
      },
    marko_attrs6 = {
        "class": "col-4 pr-50"
      },
    marko_attrs7 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      },
    marko_attrs8 = {
        "class": "col pl-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out, { page, themeMode }) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.be("form", null, "@add-user", component);

              out.be("div", marko_attrs0, "2", component);

              out.e("input", {
                  type: "text",
                  value: state.form.fullname,
                  name: "fullname",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.fullname != undefined ? state.formError.fullname ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("First & Last Name")
                }, "3", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2 " + (!state.formError.fullname ? " d-none" : ""))
                }, "4", component, null, 1);

              Locale_tag({
                  text: "Enter user's fullname is required"
                }, out, __component, "5");

              out.ee();

              out.ee();

              out.be("div", marko_attrs1, "6", component);

              out.e("input", {
                  type: "text",
                  value: state.form.email,
                  name: "email",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.email != undefined ? state.formError.email ? " is-invalid" : " is-valid" : "")),
                  validate: "required email",
                  placeholder: Locale("Email Address")
                }, "7", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2 " + (!state.formError.email ? " d-none" : ""))
                }, "8", component, null, 1);

              Locale_tag({
                  text: "Invalid Email Address"
                }, out, __component, "9");

              out.ee();

              out.ee();

              out.be("div", marko_attrs2, "10", component);

              Select_tag({
                  class: "rounded",
                  size: "xl",
                  value: state.form.accountType,
                  name: "accountType",
                  options: [
                      {
                          value: "admin",
                          label: "Administrator"
                        },
                      {
                          value: "instructor",
                          label: "Instructor"
                        },
                      {
                          value: "learner",
                          label: "Learner"
                        }
                    ],
                  placeholder: Locale("Add user as")
                }, out, __component, "11", [
                [
                  "select",
                  "__onChange",
                  false
                ]
              ]);

              out.ee();

              if (state.form.accountType == "admin") {
                out.be("div", marko_attrs3, "12", component);

                Select_tag({
                    class: "rounded",
                    size: "xl",
                    value: state.form.accountType,
                    name: "accountType",
                    options: [
                        {
                            value: "SUPER",
                            label: "SUPER ADMIN"
                          },
                        {
                            value: "SUPERVISOR",
                            label: "SUPERVISOR"
                          }
                      ],
                    placeholder: Locale("Give Administrator a Role")
                  }, out, __component, "13", [
                  [
                    "select",
                    "__onChange",
                    false
                  ]
                ]);

                get_context_tag({
                    __from: index_template,
                    renderBody: function(out, emit) {
                      out.be("p", marko_attrs4, "14", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Learn more about Administrator");
                          }
                        }, out, __component, "15");

                      out.t(" ");

                      out.be("span", marko_attrs5, "16", component, null, 0, {
                          onclick: __component.d("click", emit, false, [
                              "onHelp",
                              "Topic-ID"
                            ])
                        });

                      Locale_tag({
                          text: "Roles & Permissions"
                        }, out, __component, "17");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "28");

                out.ee();
              }

              out.n(marko_node0, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "19");

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs6, "21", component);

                    out.be("button", marko_attrs7, "22", component, null, 0, {
                        onclick: __component.d("click", "onReset", false)
                      });

                    Locale_tag({
                        text: "Reset"
                      }, out, __component, "23");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs8, "24", component);

                    out.be("button", {
                        type: "submit",
                        "class": "btn btn-primary btn-xl w-100",
                        disabled: state.submitting
                      }, "25", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.submitting
                      }, out, __component, "26");

                    Locale_tag({
                        text: "Submit"
                      }, out, __component, "27");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "20");

              out.ee();
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
